import * as React from 'react'
import { ModuleLayout } from '../../components/ModuleLayout'
import { BlipChat } from 'blip-chat-widget'
import './index.scss'

export const ChatModule: React.FC<{ isMobile?: boolean; blipChatAppKey: string }> = ({ isMobile, blipChatAppKey }: { isMobile?: boolean; blipChatAppKey: string }) => {
  const useMobile = window.innerWidth <= 576

  let data = sessionStorage.getItem('hasSession')

  if (!data) {
    localStorage.removeItem('blipSdkUAccount')
  }

  const blipClient = new BlipChat()

  const customStyle = `
    #blip-chat-header {
      display: none;
    }

    #app {
      padding-top: 0px;
      height: 100%;
    }
  `

  blipClient
    .withAppKey(blipChatAppKey)
    .withCustomCommonUrl('https://petz.chat.blip.ai/')
    .withCustomStyle(customStyle)
    .withAccount({
      extras: {
        userOrigin: 'sitePetz',
      },
    })
    .withEventHandler(BlipChat.LOAD_EVENT, function () {
      console.log('LOAD_EVENT')
      if (!data) {
        blipClient.sendMessage({
          type: 'text/plain',
          content: 'Start',
          metadata: {
            '#blip.hiddenMessage': true,
          },
        })
      }
    })

  React.useEffect(() => {
    blipClient.withTarget(useMobile ? 'chatContainerModuleMobile' : 'chatContainerModuleDesktop').build()
    sessionStorage.setItem('hasSession', 'true')
  }, [])

  return (
    <ModuleLayout>
      <div id={`chatContainerModule${isMobile ? 'Mobile' : 'Desktop'}`}></div>
    </ModuleLayout>
  )
}
